<div class="responsive-card d-flex flex-column gap-4">
  <div class="d-flex gap-2 flex-column">
    <div class="responsive-card-title" i18n>Lump Sum Details</div>
    <div
      *ngIf="!hasChanged && (currentForgoRecurringPayments || newForgoRecurringPayments)"
      class="d-flex gap-1 align-items-center">
      <img class="tooltip-img" [src]="'assets/icons/grey/CircleExclamationMark.svg'" alt="question-mark" i18n-alt />
      <div class="info" i18n>Recurring payments forgone</div>
    </div>
  </div>

  <div class="d-flex flex-column gap-3">
    <!-- No change: single white card -->
    <ng-container *ngIf="!hasChanged">
      <app-vb-scheduled-change-notice
        *ngIf="scheduledChangeNotice"
        [notices]="[scheduledChangeNotice]"
        [isLumpSum]="true" />
      <app-vb-payment-change-lump-sum-card
        [lumpSumPaymentInstruction]="currentLumpSumPaymentInstruction"
        [forgoRecurringPayments]="currentForgoRecurringPayments" />
    </ng-container>

    <!-- Change: current card (red) -->
    <div *ngIf="hasChanged" class="d-flex flex-column gap-2">
      <span class="change-label" i18n>Current</span>
      <div *ngIf="currentForgoRecurringPayments" class="d-flex gap-1 align-items-center">
        <img class="tooltip-img" [src]="'assets/icons/grey/CircleExclamationMark.svg'" alt="question-mark" i18n-alt />
        <div class="info" i18n>Recurring payments forgone</div>
      </div>
      <app-vb-payment-change-lump-sum-card
        [lumpSumPaymentInstruction]="currentLumpSumPaymentInstruction"
        [forgoRecurringPayments]="currentForgoRecurringPayments"
        [isBlank]="isCurrentBlank"
        [variant]="CardVariant.Current" />
    </div>

    <!-- Change: new card (green) -->
    <div *ngIf="hasChanged" class="d-flex flex-column gap-2">
      <span class="change-label" i18n>New</span>
      <div *ngIf="newForgoRecurringPayments" class="d-flex gap-1 align-items-center">
        <img class="tooltip-img" [src]="'assets/icons/grey/CircleExclamationMark.svg'" alt="question-mark" i18n-alt />
        <div class="info" i18n>Recurring payments forgone</div>
      </div>
      <app-vb-scheduled-change-notice
        *ngIf="scheduledChangeNotice"
        [notices]="[scheduledChangeNotice]"
        [isLumpSum]="true" />
      <app-vb-payment-change-lump-sum-card
        [lumpSumPaymentInstruction]="newLumpSumPaymentInstruction"
        [forgoRecurringPayments]="newForgoRecurringPayments"
        [isBlank]="isNewBlank"
        [variant]="CardVariant.New" />
    </div>
  </div>

  <div class="helper-text" *ngIf="currentForgoRecurringPayments || newForgoRecurringPayments" i18n>
    *Amount reflects full balance as of submission date. Final amount may vary based on payment date.
  </div>
</div>
